var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfiPool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2992_1258",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00146484 0H56.0015V56H0.00146484V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2992_1258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9304 35.8021C33.7264 35.8021 32.7468 36.7817 32.7468 37.9857V40.5039H37.114V37.9857C37.114 36.7817 36.1345 35.8021 34.9304 35.8021Z",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5159 35.8021C23.3118 35.8021 22.3323 36.7817 22.3323 37.9857V40.5039H26.6995V37.9857C26.6995 36.7817 25.7199 35.8021 24.5159 35.8021Z",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4158 32.779C21.5651 32.8331 19.3093 35.2212 19.3093 38.0724V40.5033H22.3328V38.0387C22.3328 36.8563 23.2505 35.8478 24.4321 35.8032C25.6743 35.7561 26.7 36.753 26.7 37.9851V49.7117C26.7 49.9701 26.9095 50.1797 27.168 50.1797H29.2554C29.5138 50.1797 29.7235 49.9701 29.7235 49.7117V37.9851C29.7235 35.0804 27.3328 32.7237 24.4158 32.779Z",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8254 40.5042H29.7234V43.3262H36.8254C37.6047 43.3262 38.2364 42.6944 38.2364 41.9152C38.2364 41.1359 37.6047 40.5042 36.8254 40.5042Z",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8254 46.1468H29.7234V48.9687H36.8254C37.6047 48.9687 38.2364 48.337 38.2364 47.5578C38.2364 46.7785 37.6047 46.1468 36.8254 46.1468Z",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8298 32.779C31.9791 32.8331 29.7234 35.2213 29.7234 38.0725V40.5033H32.7468V38.0387C32.7468 36.8562 33.6645 35.8478 34.8462 35.8031C36.0885 35.7562 37.1141 36.7531 37.1141 37.9851V40.533C37.7548 40.6664 38.2363 41.2339 38.2363 41.9143C38.2363 42.5945 37.7548 43.1621 37.1141 43.2954V46.1769C37.7548 46.3102 38.2363 46.8778 38.2363 47.558C38.2363 48.2383 37.7548 48.8059 37.1141 48.9392V49.7117C37.1141 49.9701 37.3236 50.1797 37.5822 50.1797H39.6696C39.9281 50.1797 40.1376 49.9701 40.1376 49.7117V37.9851C40.1376 35.0804 37.747 32.7237 34.8298 32.779Z",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8497 23.1196C36.8563 23.0851 35.8748 22.6466 35.1763 21.8026C35.0181 21.6115 34.7307 21.6115 34.5726 21.8026C33.1145 23.5645 30.4283 23.5619 28.9725 21.8026C28.8143 21.6115 28.527 21.6115 28.3688 21.8026C26.9129 23.5619 24.2269 23.5645 22.7688 21.8026C22.6105 21.6115 22.3232 21.6115 22.1651 21.8026C21.4666 22.6466 20.4849 23.0851 19.4917 23.1196",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4345 28.1906C37.2528 28.3401 36.0117 27.9103 35.1757 26.9003C35.0175 26.7091 34.7303 26.7091 34.5721 26.9003C33.114 28.6622 30.4279 28.6595 28.9719 26.9003C28.8138 26.7091 28.5265 26.7091 28.3683 26.9003C26.9124 28.6595 24.2264 28.6622 22.7682 26.9003C22.61 26.7091 22.3227 26.7091 22.1646 26.9003C21.3286 27.9103 20.0874 28.3401 18.9058 28.1906",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2242 17.9094C36.4543 17.7472 35.7271 17.3335 35.1761 16.6679C35.0179 16.4766 34.7307 16.4766 34.5725 16.6679C33.1143 18.4297 30.4283 18.4271 28.9723 16.6679C28.8142 16.4766 28.5269 16.4766 28.3687 16.6679C26.9128 18.4271 24.2267 18.4297 22.7686 16.6679C22.6104 16.4766 22.3231 16.4766 22.165 16.6679C21.614 17.3335 20.8868 17.7472 20.1169 17.9094",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2203 11.8225H16.0703C15.7081 11.8225 15.4047 12.0968 15.3684 12.4573L12.1566 39.7277C12.1367 39.9261 12.2015 40.1237 12.3353 40.2716C12.4691 40.4196 12.6591 40.5039 12.8586 40.5039H19.3091V37.9857C19.3091 35.1145 21.645 32.7786 24.5161 32.7786C27.3874 32.7786 29.7233 35.1145 29.7233 37.9857C29.7233 35.1145 32.0591 32.7786 34.9303 32.7786C37.8015 32.7786 40.1374 35.1145 40.1374 37.9857V40.5039H44.4821C44.6815 40.5039 44.8717 40.4196 45.0054 40.2716C45.1391 40.1237 45.204 39.9261 45.184 39.7277L41.9723 12.4573C41.9361 12.0968 41.6326 11.8225 41.2705 11.8225H30.1203",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6568 28.1389L44.7107 11.4865C44.568 10.0684 43.3855 8.99909 41.9602 8.99909H15.38C13.9547 8.99909 12.7724 10.0684 12.6295 11.4865L9.26414 40.283C9.10025 41.9126 10.3825 43.3242 12.0146 43.3242H26.6995V37.9842C26.6995 36.7801 25.72 35.8006 24.5159 35.8006C23.312 35.8006 22.3323 36.7801 22.3323 37.9842V40.5024H19.3089V37.9842C19.3089 35.113 21.6448 32.7772 24.5159 32.7772C27.3872 32.7772 29.723 35.113 29.723 37.9842C29.723 35.113 32.0589 32.7772 34.9301 32.7772C37.8013 32.7772 40.1371 35.113 40.1371 37.9842V43.3242H45.3256C46.9633 43.3242 48.2395 41.907 48.076 40.283L46.9957 31.0389",
    stroke: "#BC8639",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiPool);
export default __webpack_public_path__ + "static/media/infiPool.1cab4f7b7237c13ebf72bc8c34e3313a.svg";
export { ForwardRef as ReactComponent };